import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { SETTINGS_TABS, SettingsPage } from "@/features/helpdesk/settings-page";
import { ensureElementVisible } from "@/lib/route-guards";

const searchSchema = z.object({
	tab: z.enum(SETTINGS_TABS).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/helpdesk/konfiguracja")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.helpdesk.konfiguracja",
			location.pathname,
		);
	},
	validateSearch: (search: Record<string, unknown>) => searchSchema.parse(search),
	component: SettingsRoute,
});

function SettingsRoute() {
	const { tab } = Route.useSearch();
	const navigate = useNavigate({ from: "/helpdesk/konfiguracja" });
	return (
		<SettingsPage
			tab={tab ?? "skrzynka"}
			onTabChange={(next) =>
				navigate({ search: (prev) => ({ ...prev, tab: next }), replace: true })
			}
		/>
	);
}
